import { Button } from '@wartek-id/button-v1'
import { Card } from '@wartek-id/card'
import { Text } from '@wartek-id/text-v1'

export default function CardReferensi() {
  return (
    <Card className="p-6">
      <div className="flex gap-4 items-center justify-between">
        <div className="flex flex-col gap-1">
          <Text variant="heading-md">Referensi</Text>
          <Text color="subdued">
            Pusat Bantuan, regulasi, video tutorial, dan panduan lainnya sebagai
            teman pembimbing mengelola kinerja Anda.
          </Text>
        </div>
        <Button
          as="a"
          href="https://linktr.ee/pengelolaankinerjapmm"
          target="_blank"
          color="white"
        >
          Selengkapnya
        </Button>
      </div>
    </Card>
  )
}
